/**
 * View hero3 block.
 * @module components/Blocks/Hero3/View
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * View image block class.
 * @class View
 * @extends Component
 */
const View = ({ data }) => (
  <div className={['block', 'tile', 'hero'].filter((e) => !!e).join(' ')}>
    <div className="product-hero-3">
      <img src={`${data.url}/@@images/image`} alt="" />
      <div className="product-hero-3-body">
        <h1>{data.title}</h1>
        <p>{data.description}</p>
      </div>
    </div>
  </div>
);

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
